import { Box, Typography, CircularProgress, Collapse } from '@mui/material';
import MarkdownIt from 'markdown-it';

import { AuditLog, ToolResponseEventProps } from '../types';

const md = new MarkdownIt({
    breaks: true,
    linkify: true,
    typographer: true,
});

export const ToolResponseEvent = ({
    eventData,
    argumentsMetadata,
    title,
    isExpanded,
    workflowId,
}: ToolResponseEventProps) => {
    const { target_arg_name, arg_names, tool_result, content, node_id, policy_set_id } =
        eventData.audit_log as AuditLog;

    const toolResultHtml = tool_result ? md.render(tool_result) : '';

    const textElements: {
        condition: boolean | string | number | null | undefined;
        label: string;
        content: React.ReactNode | string;
        isHtml?: boolean;
    }[] = [
        {
            condition: node_id,
            label: 'Node',
            content: argumentsMetadata.isLoading ? (
                <CircularProgress size={12} sx={{ ml: 0.5, verticalAlign: 'middle' }} />
            ) : (
                title
            ),
        },
        { condition: workflowId, label: 'Workflow Id', content: workflowId },
        { condition: policy_set_id, label: 'Intent Id', content: policy_set_id },
        { condition: target_arg_name, label: 'Target Argument', content: target_arg_name },
        { condition: arg_names && arg_names.length > 0, label: 'Required Args', content: arg_names?.join(', ') },
        { condition: content, label: 'Content', content: content },
        { condition: tool_result, label: 'Result', content: toolResultHtml, isHtml: true },
    ];

    return (
        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box sx={{ ml: 2, display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                {textElements.map(
                    ({ condition, label, content, isHtml }, index) =>
                        condition && (
                            <Typography key={index} variant="body2" color="text.secondary">
                                {label && <>{label}: </>}
                                {isHtml ? (
                                    <Box
                                        component="span"
                                        sx={{ fontWeight: 700 }}
                                        dangerouslySetInnerHTML={{ __html: content as string }}
                                    />
                                ) : (
                                    <b>{content}</b>
                                )}
                            </Typography>
                        ),
                )}
            </Box>
        </Collapse>
    );
};
